export const CAISSE_CONSULT_REQUETTE = "CAISSE_CONSULT_REQUETTE";
export const CAISSE_CONSULT_SUCCES = "CAISSE_CONSULT_SUCCES";
export const CAISSE_CONSULT_ECHEC = "CAISSE_CONSULT_ECHEC";
export const CAISSE_CONSLIST_REQUETTE = "CAISSE_CONSLIST_REQUETTE";
export const CAISSE_CONSLIST_SUCCES = "CAISSE_CONSLIST_SUCCES";
export const CAISSE_CONSLIST_ECHEC = "CAISSE_CONSLIST_ECHEC";

export const CAISSE_SUPP_REQUETTE = "CAISSE_SUPP_REQUETTE";
export const CAISSE_SUPP_SUCCES = "CAISSE_SUPP_SUCCES";
export const CAISSE_SUPP_ECHEC = "CAISSE_SUPP_ECHEC";
